export default __webpack_public_path__ + "static/media/ripples.e48466c2.gif";